var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDebtsIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5015 13.5C4.5015 15.1575 7.85849 16.5 12.0015 16.5",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5C7.8585 22.5 4.5015 21.1575 4.5015 19.5",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4985 7.5H19.5V12",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5015 24C16.5015 25.6575 19.8585 27 24.0015 27C28.1445 27 31.5015 25.6575 31.5015 24",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5015 18C16.5015 19.6575 19.8585 21 24.0015 21C28.1445 21 31.5015 19.6575 31.5015 18",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15C19.86 15 16.5 16.3425 16.503 18",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5015 18V30C16.5015 31.6575 19.8585 33 24.0015 33",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15C28.14 15 31.5 16.3425 31.497 18",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 18V30C31.5 31.6575 28.143 33 24 33",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 28.5C7.8585 28.5 4.5 27.1575 4.5 25.5",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.5C16.1421 10.5 19.5 9.15685 19.5 7.5C19.5 5.84315 16.1421 4.5 12 4.5C7.85786 4.5 4.5 5.84315 4.5 7.5C4.5 9.15685 7.85786 10.5 12 10.5Z",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.5V25.5",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDebtsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DebtsIcon.08e8b628.svg";
export { ForwardRef as ReactComponent };